// @see http://192.168.9.242:8090/pages/viewpage.action?pageId=11539896
export const ResponseCode = {
  TOKEN_EMPTY: 4000006, // 缺少token参数 TOKEN_LOST
  TOKEN_TIMEOUT: 4000000, // token失效
  TOKEN_CHECK_FAILURE: 4000003, // 无效token
  UNACCESSABLE: 4009988, // 无效请求，无权限
};
